import styled from 'styled-components';
import ButtonMui from '@mui/material/Button';

export const Header = styled.div`
  background-color: #EAF0F6;
  width: 100%;
  padding: 20px;
  color: #48596B;
  h2 {
    font-size: 32px;
    font-weight: normal;
    color: #595959;
  }
  b {
    font-size: 24px;
    font-weight: bold;
    padding: 0 10px;
  }
  img {
    height: 60px;
  }
`;

export const Button = styled(ButtonMui)`
  flex: 1;
  span {
    text-transform: none !important;
    font-size: 16px;
    font-weight: 700;
  }
  max-width: 200px;
`;

export const ButtonBar = styled.div`
  display: flex;
  align-items: center;
  max-height: 80px;
  & > *:not(:first-child) {
    margin-left: 10px !important;
  }
  label#field_1 span {
  padding-top: 5px;
  padding-bottom: 5px;
  }
  .MuiButtonBase-root span {
    padding-top: 4px;
    padding-bottom: 4px;
  }
`;

export const RowSpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Divider = styled.div`
  width: 100%;
  border-top: 1px solid #CBD6E2;
  margin: 20px 0;
`;

export const Container = styled.div`
  label {
    font-size: 16px;
    font-weight: bold;
    color: #595959;
  }
  input, textarea {
    background-color: white;
  }
`;

export const Body = styled.div`
  position: relative;
  width: 100%;
  background-color: #F9F9F9;
  display: flex;
  justify-content: center;

  h2 { 
    color: #595959;
    font-size: 24px;
    font-weight: bold;
    line-height: 65px;
  }
  h3 { 
    color: #595959;
    font-size: 16px;
    font-weight: bold;
  }
  .MuiCheckbox-root {
    color: #F89915 !important;
  }
  .MuiInputBase-root {
    background-color: #ffffff !important;
  }
`;

export const Root = styled.div`
  ${({ maxWidth }) => maxWidth && `max-width: ${maxWidth}px`}
  align-self: center;
  margin-bottom: 20px;
`;

export const FieldRow = styled.div`
  display: flex;
  align-items: center;
  span {
    margin-left: 10px;
  }
`;